// Projeto: Haklai Church — Plugin WordPress Modular - Desenvolvido por: Ricardo Sarmento - https://linx.pt

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Valida email
      if (!email || !email.includes('@')) {
        setError('Por favor, informe um email válido');
        setLoading(false);
        return;
      }

      // Envia requisição
      await api.post('/auth/forgot-password', { email });

      // Mostra mensagem de sucesso
      setSuccess(true);
      setEmail('');

    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Erro ao solicitar recuperação de senha');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      {/* Hero Side */}
      <div className="auth-hero">
        <div className="auth-hero-content">
          <div className="auth-logo">H</div>
          <h1>Haklai Church</h1>
          <p>Recupere o acesso à sua conta em poucos passos.</p>
        </div>
      </div>

      {/* Form Side */}
      <div className="auth-form-side">
        <div className="auth-form-container">
          {/* Header */}
          <div className="auth-form-header">
            <h2>Recuperar Senha</h2>
            <p>Informe seu email e enviaremos instruções para redefinir sua senha</p>
          </div>

          {success ? (
            <div style={{ textAlign: 'center', padding: '2rem 0' }}>
              <div style={{ 
                width: '64px', 
                height: '64px', 
                borderRadius: '50%', 
                background: 'var(--success-light)', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                margin: '0 auto 1.5rem'
              }}>
                <span className="material-symbols-outlined" style={{ fontSize: '2rem', color: 'var(--success)' }}>
                  check_circle
                </span>
              </div>
              <h3 style={{ marginBottom: '0.5rem' }}>Email Enviado!</h3>
              <p style={{ color: 'var(--text-secondary)', marginBottom: '2rem' }}>
                Se o email informado estiver cadastrado, você receberá instruções para redefinir sua senha em breve.
                <br />
                <strong>Verifique sua caixa de entrada e spam.</strong>
              </p>
              <button
                className="btn btn-primary btn-block"
                onClick={() => navigate('/login')}
              >
                Voltar ao Login
              </button>
            </div>
          ) : (
            <form className="auth-form" onSubmit={handleSubmit}>
              {error && (
                <div className="alert alert-error">
                  {error}
                </div>
              )}

              <div className="form-group">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-input"
                  placeholder="seu@email.com"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setError('');
                  }}
                  required
                  disabled={loading}
                  autoFocus
                />
                <p style={{ fontSize: '0.875rem', color: 'var(--text-muted)', marginTop: '0.5rem' }}>
                  Enviaremos um link de recuperação para este email
                </p>
              </div>

              <button
                type="submit"
                className="btn btn-primary btn-block btn-lg auth-submit"
                disabled={loading || !email}
              >
                {loading ? (
                  <>
                    <span className="material-symbols-outlined" style={{ animation: 'spin 1s linear infinite' }}>
                      refresh
                    </span>
                    Enviando...
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined">send</span>
                    Enviar Instruções
                  </>
                )}
              </button>

              <div style={{ textAlign: 'center', marginTop: '1.5rem' }}>
                <a 
                  href="#/login" 
                  onClick={(e) => { e.preventDefault(); navigate('/login'); }}
                  style={{ color: 'var(--primary)', textDecoration: 'none' }}
                >
                  ← Voltar ao Login
                </a>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
